import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";
import { RemoveFileRecordDialog } from "./RemoveFileRecordDialog";
import { mapToRemoveFileRecordItem } from "./RemoveFileRecordItem";

export const RemoveFileRecordButton: React.VFC = () => {
    const { selectedItems } = useContext(FileRecordListingContext);
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <CommandBarButton text="Remove" icon="Delete" disabled={!selectedItems.length} onClick={onOpen} />
            <RemoveFileRecordDialog
                key={String(isOpen)}
                isOpen={isOpen}
                onClose={onClose}
                selectedItems={selectedItems.map(mapToRemoveFileRecordItem)}
            />
        </AuthorizationWrapper>
    );
};
